module.exports = {
	title:'系统设置',
	opeaddress:'运营地址',
	opeholder:'请输入运营地址',
	wechatpay:'微信支付分参数',
	wechat:'微信支付参数',
	not:'短信模板设置',
	aloss:'阿里OSS',
	appId:'微信支付AppId(AppID)',
	appIdholder:'请输入微信支付AppId',
	appSecret:'微信支付AppSecret(AppSecret)',
	secretholder:'请输入微信支付AppSecret',
	mchId:'微信支付商户号',
	mchIdholder:'请输入微信支付商户号',
	mchKey:'微信支付商户密钥',
	mchkeyholder:'请输入微信支付商户密钥',
	serverId:'服务ID',
	serverholder:'请输入服务ID',
	serverInfo:'服务信息',
	serverinfoholder:'请输入服务信息',
	privateKey:'私钥',
	privateholder:'请输入私钥',
	privateKeyzs:'私钥证书',
	zsholder:"请输入私钥证书",
	apiKey:'API v3密钥',
	apiv3holder:'请输入API v3密钥',
	baseurl:'微信支付接入点地址',
	baseholder:'请输入微信支付接入点地址',
	payscoreIotClient:'收付通模式',
	api:'API密钥',
	apiholder:'请输入API密钥',
	subappId:'子商户 AppId(AppID)',
	subappholder:'请输入子商户AppId',
	submch:'子商户号',
	submchholder:'请输入子商户号',
	signtype:'签名类型',
	p12:'p12证书',
	p12holder:'请输入P12证书',
	signname:'签名名称',
	nameholder:'请输入签名名称',
	AccessKeyID:'AccessKey ID',
	accidholder:'请输入AccessKey ID',
	AccessKeySecret:'AccessKey Secret',
	accserholder:'请输入AccessKey Secret',
	sms:'短信接入点',
	smsholder:'请输入短信接入点',
	smstpl:'短信模板',
	logincode:'登录验证码',
	codeholder:'请输入登录验证码',
	endpoint:'地域节点',
	pointholder:"请输入地域节点",
	oss:'OSS接入点',
	ossholder:'请输入OSS接入点',
	roleArn:'roleArn',
	arnholder:'请输入roleArn',
	policy:'策略内容',
	polholder:'请输入策略内容',
	sessionname:'会话名称',
	sessnameholder:'请输入会话名称',
	sessiontime:'会话失效时间',
	timeholder:'请输入900秒～3600秒之间的会话失效时间',
	bucketName:'Bucket Name',
	bucketPath:'Bucket Path',
	bnameholder:'请输入Bucket 名称',
	bpathholder:'请输入Bucket 路径',
	types:{
		md5:'MD5',
		hmac:'HMAC-SHA256'
	}
}



// WEBPACK FOOTER //
// ./src/i18n/locales/zh-cn/modules/system.js